import moment from "moment";
import { BulkUploadModal, ViewModal, pinVerificationModal } from "./Modal";
import { FilterForm } from "./Form/filter";

export const WalletUploadListLayout = {
  content: {
    type: 'div',
    children: [
      {
        //section: page title
        type: 'div',
        className: 'col-12',
        children: [
          {
            type: 'page-title',
            heading: '{{WALLET_UPLOAD_LIST}}',
            path: [
              {
                text: '{{WALLETS}}',
                disabled: true,
              },
              {
                text: '{{WALLET_UPLOAD_LIST}}',
                disabled: true,
              },
            ],
          },
        ],
      },
      {
        //section: content
        type: 'div',
        className: 'col-12',
        children: [
          {
            //section: card
            type: 'card',
            children: [
              {
                //section: card action buttons
                type: 'div',
                className: 'd-flex justify-content-end w-100 mb-4',
                children: [
                  {
                    type: 'button',
                    isHide: 'noCreatePermission',
                    buttonType: 'text',
                    className: 'custom-color',
                    style: { backgroundColor: '$quaternary', color: '#ffffff' },
                    actionKey: 'OPEN_BULK_UPLOAD_MODAL',
                    size: 'large',
                    children: [
                      {
                        type: 'text',
                        content: '{{BULK_UPLOAD}}',
                      },
                    ],
                  }
                ]
              },
              {
                type: 'collapse',
                defaultActiveKey: [0],
                className: 'mb-4',
                panels: [
                  FilterForm
                ]
              },
              {
                type: "table",
                dataKey: "rows",
                metadataKey: "meta",
                updateTableInfo: "UPDATE_TABLE_INFO",
                actionsContent: [
                  {
                    type: 'drop-down',
                    trigger: 'click',
                    placement: 'bottomRight',
                    actionKey: 'ACTIONS',
                    param: [ 'rowData' ],
                    menuProps: [
                      {
                        label: "{{VIEW}}",
                        key: 'view'
                      },
                    ],
                    children: [
                      {
                        type: 'text',
                        className: 'mr-2',
                        content: "{{ACTIONS}}"
                      },
                      {
                        type: 'icon',
                        antIcon: 'DownOutlined'
                      }
                    ]
                  }
                ],
                columnsContent: [
                  {
                    Header: "{{INDEX_NO}}",
                    accessor: "$index",
                    disableFilters: true,
                    disableSortBy: true,
                  },
                  {
                    Header: "{{REMARKS}}",
                    accessor: "remarks",
                    disableFilters: true,
                    disableSortBy: true,
                  },
                  {
                    Header: "{{STATUS}}",
                    accessor: "status",
                    disableFilters: true,
                    disableSortBy: true,
                    function: (val) => <div style={{textTransform: 'capitalize'}}>{val.replaceAll("_", " ")}</div>
                  },
                  {
                    Header: "{{TYPE}}",
                    accessor: "type",
                    disableFilters: true,
                    disableSortBy: true,
                    function: (val) => <div style={{textTransform: 'capitalize'}}>{val.replaceAll("_", " ")}</div>
                  },
                  {
                    Header: "{{CREATED_DATE}}",
                    accessor: "createdAt",
                    disableFilters: true,
                    disableSortBy: true,
                    function: (val) => moment(val).format('YYYY-MM-DD[,] hh:mm:ssA')
                  },
                  {
                    Header: "{{CREATED_BY}}",
                    accessor: "creator.username",
                    disableFilters: true,
                    disableSortBy: true,
                  },
                  {
                    Header: "{{REVIEWED_BY}}",
                    accessor: "reviewer.username",
                    disableFilters: true,
                    disableSortBy: true,
                  },
                ]
              },
            ],
          }
        ]
      },
      BulkUploadModal,
      ViewModal,
      pinVerificationModal
    ]
  }
}